import { frontendURL } from '../../../helper/URLHelper';

import CaptainPageRouteView from './pages/CaptainPageRouteView.vue';
import { brainRoutes } from './brain/brain.routes';

// Faxina 2026-08: as telas legadas do Captain foram aposentadas — a UI oficial
// e a do Brain (brain.routes). Os NOMES das rotas antigas continuam validos
// como redirects para deep links e navegacoes antigas nao quebrarem.
const redirecionar = destino => to => ({
  name: destino,
  params: {
    accountId: to.params.accountId,
    ...(to.params.assistantId ? { assistantId: to.params.assistantId } : {}),
  },
});

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/faqs'),
    name: 'captain_assistants_responses_index',
    redirect: redirecionar('brain_wizard_knowledge'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/documents'),
    name: 'captain_assistants_documents_index',
    redirect: redirecionar('brain_wizard_knowledge'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/tools'),
    name: 'captain_tools_index',
    redirect: redirecionar('brain_wizard_tools'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/scenarios'),
    name: 'captain_assistants_scenarios_index',
    redirect: redirecionar('brain_wizard_identity'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/scripts'),
    name: 'captain_assistants_scripts_index',
    redirect: redirecionar('brain_wizard_flow'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/skills'),
    name: 'captain_assistants_skills_index',
    redirect: redirecionar('brain_wizard_tools'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/playground'),
    name: 'captain_assistants_playground_index',
    redirect: redirecionar('brain_wizard_playground'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/inboxes'),
    name: 'captain_assistants_inboxes_index',
    redirect: redirecionar('brain_wizard_connect'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/faqs/pending'),
    name: 'captain_assistants_responses_pending',
    redirect: redirecionar('brain_wizard_knowledge'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/settings'),
    name: 'captain_assistants_settings_index',
    redirect: redirecionar('brain_wizard_identity'),
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/guardrails'
    ),
    name: 'captain_assistants_guardrails_index',
    redirect: redirecionar('brain_wizard_identity'),
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/guidelines'
    ),
    name: 'captain_assistants_guidelines_index',
    redirect: redirecionar('brain_wizard_identity'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/assistants'),
    name: 'captain_assistants_create_index',
    redirect: redirecionar('brain_assistants_index'),
  },
  {
    path: frontendURL('accounts/:accountId/captain/:navigationPath'),
    name: 'captain_assistants_index',
    redirect: redirecionar('brain_assistants_index'),
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/captain'),
    component: CaptainPageRouteView,
    redirect: to => ({
      name: 'brain_assistants_index',
      params: { accountId: to.params.accountId },
    }),
    children: [...brainRoutes, ...assistantRoutes],
  },
];
